import axiosConfig from "./axiosConfig";
import { HealthEvent } from "./getSiteHealthEvents";

export interface UpdateHealthEventRequest {
  impactType?: string;
  notes?: string | null;
  category?: string;
  severity?: string;
  detectedAt?: string;
  resolvedAt?: string | null;
  /** "Which Excludable Event" reason. Required (in this request or already on the
   * event) when setting impactType to an excused variant (`*_excused`), which
   * removes the outage from both the numerator and the denominator of availability. */
  exclusionReason?: string | null;
}

const updateHealthEvent = async (
  authToken: string,
  siteId: string,
  eventId: number,
  update: UpdateHealthEventRequest
): Promise<HealthEvent> => {
  const { data } = await axiosConfig.patch(
    `/site/${siteId}/health/events/${eventId}`,
    update,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default updateHealthEvent;
